
<ul class="ws-list">
  <li
    v-for="(item, index) in items"
    :key="index"
  >
    <div class="dot">
      <slot name="bullet">
        <ws-icon
          class="default-icon"
          color="ws-red"
          :size="18"
          name="circle_bullet"
        />
      </slot>
    </div>
    <div class="item">
      <slot
        :index="index"
        :item="item"
      >
        {{ item }}
      </slot>
    </div>
  </li>
</ul>
